// extracted by mini-css-extract-plugin
export default {"risk-image__container":"style_risk-image__container__1BPbL","risk-image__box":"style_risk-image__box__uWqrd"};